import { apiHolder as api } from 'api';
import lodashGet from 'lodash/get';
const httpApi = api.api.getDataTransApi();
const isSupportPaste = async () => {
    if (window.navigator && window.navigator.clipboard && typeof window.navigator.clipboard.readText === 'function') {
        try {
            await navigator.clipboard.readText();
            return true;
        }
        catch (e) {
            return false;
        }
    }
    return false;
};
export const writeImagePng = (base64Url) => {
    const image = new Image();
    image.onload = async () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = image.width;
        canvas.height = image.height;
        if (ctx !== null && ClipboardItem && (await isSupportPaste())) {
            ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
            ctx.drawImage(image, 0, 0);
            canvas.toBlob(async (blob) => {
                navigator.clipboard.write([
                    new ClipboardItem({
                        [blob.type]: blob,
                    }),
                ]);
            });
        }
        image.remove();
        canvas.remove();
    };
    image.src = base64Url;
};
export const getImageFormatFromUrl = (url, fileName, formatType = 'base64') => new Promise((resolve, reject) => {
    const noContentTypeInit = url && (url.includes('cowork-storage.nos-jd.163yun.com') || url.includes('cowork-storage-public.nos-jd.163yun.com')) ? true : false;
    httpApi
        .get(url, {}, Object.assign({ responseType: 'blob' }, (noContentTypeInit ? { contentType: '' } : {})))
        .then(data => {
        const blob = data.rawData;
        if (!blob) {
            reject();
        }
        if (formatType === 'blob') {
            resolve(blob);
        }
        const file = new File([blob], fileName, { type: fileName });
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = e => {
            const base64Url = lodashGet(e, 'target.result', '');
            writeImagePng(base64Url);
            resolve(base64Url);
        };
    });
}).catch(() => Promise.reject());
